import client from "./client";

const individualApi = {
  // Tutors
  listTutors() {
    return client.get("/individual/tutors").then((r) => r.data);
  },
  createTutor(body) {
    return client.post("/individual/tutors", body).then((r) => r.data);
  },
  updateTutor(id, body) {
    return client.patch(`/individual/tutors/${id}`, body).then((r) => r.data);
  },
  logClass(tutorId, body) {
    return client.post(`/individual/tutors/${tutorId}/classes`, body).then((r) => r.data);
  },
  addPayment(tutorId, body) {
    return client.post(`/individual/tutors/${tutorId}/payments`, body).then((r) => r.data);
  },

  // Exams
  listExams(params = {}) {
    return client.get("/individual/exams", { params }).then((r) => r.data);
  },
  createExam(body) {
    return client.post("/individual/exams", body).then((r) => r.data);
  },

  // Papers
  listPapers() {
    return client.get("/individual/papers").then((r) => r.data);
  },
  createPaper(body) {
    return client.post("/individual/papers", body).then((r) => r.data);
  },

  // Study slots
  listStudySlots() {
    return client.get("/individual/study-slots").then((r) => r.data);
  },
  createStudySlot(body) {
    return client.post("/individual/study-slots", body).then((r) => r.data);
  },
  updateStudySlot(id, body) {
    return client.patch(`/individual/study-slots/${id}`, body).then((r) => r.data);
  },
  deleteStudySlot(id) {
    return client.delete(`/individual/study-slots/${id}`).then((r) => r.data);
  },

  // Tasks
  listTasks(params = {}) {
    return client.get("/individual/tasks", { params }).then((r) => r.data);
  },
  createTask(body) {
    return client.post("/individual/tasks", body).then((r) => r.data);
  },
  updateTask(id, body) {
    return client.patch(`/individual/tasks/${id}`, body).then((r) => r.data);
  },
  deleteTask(id) {
    return client.delete(`/individual/tasks/${id}`).then((r) => r.data);
  },
};

export default individualApi;
